import React, { Component } from 'react';
import styled from 'styled-components';

import { Heading2, BoxTitleLabelOnTopOfImg } from '../..';
import color from '../../colors';
import { media } from '../../../utils/Helper';

const DescriptionDiv = styled.div`
  margin: 0 auto;
  text-align: center;
  margin-bottom: 5.5rem;
`;

const FlexDiv = styled.div`
  display: flex;
  justify-content: center;
  ${media.tablet`
  flex-direction: column;
  align-items: center;
  `}
`;
const ProgramDiv = styled.div`
  background-color: ${color.lightGray};
  margin-right: calc(((100vw - 100%) / 2) * -1);
  margin-left: calc(((100vw - 100%) / 2) * -1);
  padding: 84px 7.5%;
`;
const BoxDiv = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

interface ownProps {
  data: any;
}
interface ownState {}
class SchoolProgramBox extends Component<ownProps> {
  programItemDom(data: any) {
    let programData = [
      {
        title: data.programTitle1,
        subTitle: data.programSubtitle1,
        color: data.programColor1,
        img: data.programImg1,
        link: data.programLink1,
      },
      {
        title: data.programTitle2,
        subTitle: data.programSubtitle2,
        color: data.programColor2,
        img: data.programImg2,
        link: data.programLink2,
      },
    ];

    let returnDom: JSX.Element[] = [];

    programData.map((x, index) =>
      returnDom.push(
        <BoxTitleLabelOnTopOfImg
          key={index}
          title={x.title}
          subTitle={x.subTitle}
          backgroundColor={x.color}
          img={x.img}
          buttonLink={x.link}
          className={'school-item'}
        />,
      ),
    );
    return returnDom;
  }

  render() {
    return (
      <ProgramDiv>
        <BoxDiv>
          <Heading2>提携学校・プログラムの種類一覧</Heading2>
          <DescriptionDiv
            dangerouslySetInnerHTML={{
              __html: this.props.data.pageDescription,
            }}
          />
          <FlexDiv>{this.programItemDom(this.props.data)}</FlexDiv>
        </BoxDiv>
      </ProgramDiv>
    );
  }
}
export default SchoolProgramBox;
